// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input__root--_a_S {
    width: 100%;
}

.Input__label--lDci {
    display: block;
    font-size: 16px;
    line-height: 1.5;
    font-weight: 600;
    margin-bottom: 8px;
    color: var(--secondary-color)
}

.Input__container--EzR0 {
    width: 100%;
    position: relative;
}

.Input__input--fHKp {
    width: 100%;
    outline: none;
    transition: border-color 0.3s ease;
    background-color: var(--main-light-color);
    border: 1px solid var(--gray-color);
    color: var(--secondary-color);
    padding: 12px 16px;
    border-radius: 12px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
}

.Input__input--fHKp.Input__withIndent--WU_a {
        padding-right: 40px;
    }

.Input__input--fHKp::-moz-placeholder {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: var(--gray-color);
        font-family: var(--font-family);
    }

.Input__input--fHKp::placeholder {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: var(--gray-color);
        font-family: var(--font-family);
    }

.Input__input--fHKp:disabled {
        background-color: var(--obscure-color);
        border-color: #B8BFD2;
        pointer-events: none;
    }

.Input__input--fHKp:disabled::-moz-placeholder {
            color: #B8BFD2;
        }

.Input__input--fHKp:disabled::placeholder {
            color: #B8BFD2;
        }

.Input__input--fHKp::-webkit-search-decoration,
    .Input__input--fHKp::-webkit-search-cancel-button,
    .Input__input--fHKp::-webkit-search-results-button,
    .Input__input--fHKp::-webkit-search-results-decoration {
        -webkit-appearance: none;
    }

.Input__input--fHKp:focus {
        border-color: var(--main-color);
    }

.Input__input--fHKp:focus::-moz-placeholder {
            color: transparent;
            opacity: 0;
        }

.Input__input--fHKp:focus::placeholder {
            color: transparent;
            opacity: 0;
        }

.Input__input--fHKp.Input__error--gPP0 {
        border-color: var(--error-color);
    }

.Input__alert--sosR {
    color: var(--error-color);
    font-size: 14px;
    font-weight: 600;
    margin-top: 8px;
}

.Input__icon--wgjn {
    position: absolute;
    bottom: 14px;
    right: 12px;
    width: 24px;
    height: 24px;
}

.Input__iconClear--ILv8 {
    color: var(--main-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/Input/Input.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,yCAAyC;IACzC,mCAAmC;IACnC,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;AA4CpB;;AA1CI;QACI,mBAAmB;IACvB;;AAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,wBAAwB;QACxB,+BAA+B;IACnC;;AANA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,wBAAwB;QACxB,+BAA+B;IACnC;;AAEA;QACI,sCAAsC;QACtC,qBAAqB;QACrB,oBAAoB;IAMxB;;AAHI;YACI,cAAc;QAClB;;AAFA;YACI,cAAc;QAClB;;AAGJ;;;;QAII,wBAAwB;IAC5B;;AAEA;QACI,+BAA+B;IAMnC;;AAJI;YACI,kBAAkB;YAClB,UAAU;QACd;;AAHA;YACI,kBAAkB;YAClB,UAAU;QACd;;AAGJ;QACI,gCAAgC;IACpC;;AAGJ;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[".root {\n    width: 100%;\n}\n\n.label {\n    display: block;\n    font-size: 16px;\n    line-height: 1.5;\n    font-weight: 600;\n    margin-bottom: 8px;\n    color: var(--secondary-color)\n}\n\n.container {\n    width: 100%;\n    position: relative;\n}\n\n.input {\n    width: 100%;\n    outline: none;\n    transition: border-color 0.3s ease;\n    background-color: var(--main-light-color);\n    border: 1px solid var(--gray-color);\n    color: var(--secondary-color);\n    padding: 12px 16px;\n    border-radius: 12px;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    appearance: none;\n\n    &.withIndent {\n        padding-right: 40px;\n    }\n\n    &::placeholder {\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 24px;\n        color: var(--gray-color);\n        font-family: var(--font-family);\n    }\n\n    &:disabled {\n        background-color: var(--obscure-color);\n        border-color: #B8BFD2;\n        pointer-events: none;\n\n\n        &::placeholder {\n            color: #B8BFD2;\n        }\n    }\n\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n        -webkit-appearance: none;\n    }\n\n    &:focus {\n        border-color: var(--main-color);\n\n        &::placeholder {\n            color: transparent;\n            opacity: 0;\n        }\n    }\n\n    &.error {\n        border-color: var(--error-color);\n    }\n}\n\n.alert {\n    color: var(--error-color);\n    font-size: 14px;\n    font-weight: 600;\n    margin-top: 8px;\n}\n\n.icon {\n    position: absolute;\n    bottom: 14px;\n    right: 12px;\n    width: 24px;\n    height: 24px;\n}\n\n.iconClear {\n    color: var(--main-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Input__root--_a_S`,
	"label": `Input__label--lDci`,
	"container": `Input__container--EzR0`,
	"input": `Input__input--fHKp`,
	"withIndent": `Input__withIndent--WU_a`,
	"error": `Input__error--gPP0`,
	"alert": `Input__alert--sosR`,
	"icon": `Input__icon--wgjn`,
	"iconClear": `Input__iconClear--ILv8`
};
export default ___CSS_LOADER_EXPORT___;
